// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__rDnFO","footer":"ModalCreateQualiphyProcedure_footer__1dasE","additionData":"ModalCreateQualiphyProcedure_additionData__35ya8"};